import { useQuery } from "@tanstack/react-query";
import { alertasApi } from "../api/alertasApi";

export function useAlertasQuery() {
  return useQuery({ queryKey: ["alertas"], queryFn: alertasApi.list });
}
